import React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import MDButton from "../../../materialDashboard/components/MDButton";


const L1InfoDialog = ({l1Registry, dialog}) => {
    const {t} = useTranslation(['models1']);

    return <Dialog onClose={dialog.close}
            open={dialog.isOpen}
            maxWidth="lg"
            fullWidth>
        <DialogTitle>{t("infoDialog.l1.title")}</DialogTitle>
        <DialogContent>
            <TableContainer sx={{boxShadow: "none"}}>
                <Table sx={{"& tbody .MuiTableRow-root:hover": {backgroundColor: "#f8f9fa"}}}>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell component="th">{t("infoDialog.l1.code")}</TableCell>
                            <TableCell component="th">{t("infoDialog.l1.name")}</TableCell>
                            <TableCell component="th">{t("infoDialog.l1.volume")}</TableCell>
                            <TableCell component="th">{t("infoDialog.l1.length")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {l1Registry.map((row) => (
                            <TableRow key={row.code} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                    {row.code}
                                </TableCell>
                                <TableCell>{row.observation}</TableCell>
                                <TableCell>{row.volumeDesc}</TableCell>
                                <TableCell>{row.lengthDesc}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
        <DialogActions>
            <MDButton onClick={dialog.close} color="info" variant="outlined">
                {t('infoDialog.l1.close')}
            </MDButton>
        </DialogActions>
    </Dialog>
}

export default L1InfoDialog;